import React, { useEffect, useState } from 'react'
import Layout from '../../components/global/layout'
import methodModel from '../../methods/methods'
import ApiClient from '../../methods/api/apiClient'
import loader from '../../methods/loader'
import { useNavigate, useParams } from 'react-router-dom'

const viewRequest = () => {
  const history = useNavigate()
  const { assessmentId } = useParams()
  const [data, setdata] = useState('')

  useEffect(() => {
    getData(assessmentId)
  }, [])

  const getData = (id) => {
    loader(true)
    ApiClient.get(`user/assesssment/details?id=${id}`).then(res => {
      if (res?.success) {
        setdata(res?.data)
        loader(false)
      }
    })
  }

  const back = () => {
    history(-1)
  }
  return (
    <Layout>
      <div className="pprofile1 shadow-lg">
        <div className="flex items-center mb-8">
          <button
            type="button"
            class="!px-4 bg-[#fff] py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all mr-3"
            to="/users"
            onClick={back}
          >
            <i class="fa fa-angle-left text-lg"></i>
          </button>
          <div>
            <h3 className="text-2xl font-semibold text-[#111827]">
              View Assessment
            </h3>
            <p className="text-sm font-normal text-[#525252]">
              Here you can see all about User Assessment
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Assessment Name</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {methodModel.capitalizeFirstLetter(data?.assessment_details?.name)}
            </div>
          </div>

          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Weightage</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data?.score_details?.weightage}
            </div>
          </div>
          
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Minimum Score </label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data?.score_details?.minimum_score}
            </div>
          </div>

          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Result</label>
            <div className="capitalize profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data?.score_details?.result}
            </div>
          </div>

          
          <div className="col-span-12 md:col-span-12">
            <label className="profileheddingcls">Question </label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md mb-1">
    {console.log(data, 'data')}
              {data?.attempt_question_details?.map((itm,i) => {
                
                return (<div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md mb-1">
                 <div>
                  <label className='profileheddingcls'>
                 Q{i+1}: {itm?.question_name}
                  </label>
                  </div>
                  <div>
                  <label>
                 A: {itm?.answer||'--'}
                  </label>
                  </div>
                  <div>
                  <label className='text-[#000]'>
                 Status: <label className={itm?.is_correct_answer?'text-[#1cac5b]':'text-[#ff0000]'}>{itm?.is_correct_answer?'Correct':'Wrong Answer'}
                  </label>
                  </label>
                  </div>
                  
                </div>)
              })
              }
            </div>
              Attempt {data?.attempt_question} from {data?.total_length} Questions
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default viewRequest